import {GLOBAL_ENVIRONMENT} from './global';

export const environment = {
  ...GLOBAL_ENVIRONMENT,
  production: true
};
